import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { ReportService } from './report.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Injectable({
  providedIn: 'root'
})
export class ToplineService {
  public isToplineParameter: boolean = false;
  public sidecutArrayForPriority:any[]=[]
  public isToplineAlias: boolean = true;
  public isLoading: boolean = false;
  public linearDataList:any = {"tables":[],"topcut":[],"sidecut":[]};
  public sidecutV2:any = [];
  public topcutV2:any = [];
  public listTypes: any = {tableList:[],topcutList:[],sidecutList:[]};
  public searchText:string = "";
  public activeTab:string = "tables";
  public activeTreeTab:string = "top cuts";
  public listItems: any = {};
  public activatedPrefix:any="";
  public fileDetails:any = {};
  public aliasData: any = {}
  public isAliasData: boolean = false
  public aliastoTableBackButtonShow:boolean = false;
  public sidecutTreeitems:any = {};
  public valueTreeitems:any = {};
  public isTopcutLoaded:boolean = false;
  public isSidecutLoaded:boolean = false;
  public isTavleCutLoaded:boolean = false;
  public treeItems:any = {};
  public sidecutTreeJSON:any = [];
  public valueTreeJSON:any = [];
  public dataTreeJSON:any = [];
  public originalToplineTreeItems:any = {"table":[],"topcut":[],"sidecut":[]};
  public toplineTreeItems:any = {"table":[],"topcut":[],"sidecut":[]};
  public customOptionTree:any[] = [];
  public sheetContainerIndex = 0;
  public excelviewer_fileUUID:string = ""
  public crosstab_fileUUID:string = ""
  public currentTable:any = {};
  public currentTableRowsThatHasStyle:any = {};
  public currentTableJson:any = {};
  public table_id:string ="";
  httpPostOptionsFile = {
    withCredentials: true
  };
  public filterStreetData:any = [];
  public tableListForToplineParams:any = [];
  public hardCopySideCut:any = [];
  public is_header:boolean = false;
  public aliasFileDetail:any = {};

  constructor(
      public reportService:ReportService,
      public notifier: NotifierService,
      private formBuilder: FormBuilder,
      private apiRequest: ApiRequestService,
      public router:Router,
      private sidePanelService:SidePanelService
     ) { 
      this.reportService.emitFileDetails.subscribe((fileDetails)=>{
        this.fileDetails = fileDetails;
        this.viewCreateTopline(fileDetails);
      });
    }

  setCrosstabFileUUID(uuid:string){
    this.crosstab_fileUUID = uuid;
  }
  setExcelviewerFileUUID(uuid:string){
    this.excelviewer_fileUUID = uuid;
  }

  createTable() {
    this.resetToOriginalTree()
    this.table_id = "";
    this.isToplineParameter = true;
  }
  resetToOriginalTree(){
    this.toplineTreeItems = JSON.parse(JSON.stringify(this.originalToplineTreeItems));
  }
  editTable(currentTableData:any, table_id) {
    this.isToplineParameter = true;
    this.table_id = table_id +"";
    this.currentTableRowsThatHasStyle = {};
    setTimeout(() => {
      this.currentTable = currentTableData;   
      this.setSidecutHistory();
      // console.log("currentTable in topline service =====> ", this.currentTable) 
      this.currentTable["sidecut"].forEach((sCut,index) => {
        let item = this.searchTree(this.toplineTreeItems["sidecut"][0],sCut.id);
        if(item && item != null){
          item["selectionOrder"] = sCut["selectionOrder"]
          if(sCut && sCut['style'] && Object.keys(sCut['style']).length){
            item['style'] = sCut['style'];
          }
        }
        if (sCut.style) {
          this.currentTableRowsThatHasStyle[sCut.uuid] = sCut;
        }
      });
      let baseLessSidecut:any[] = currentTableData['sidecut'];
      // console.log("baseLessSidecut",baseLessSidecut)
      baseLessSidecut  = baseLessSidecut.filter((va:any) =>{
        return va.name.startsWith('Base') ? false : true;
      })
      this.hardCopySideCut = JSON.stringify(baseLessSidecut);
    }, 500);
  }
  // sortSelectedTreeItems(){
  //   if (this.currentTable["topcut"] && this.currentTable["topcut"].length) {
  //     // this.toplineTreeItems["topcut"] = this.sortTreeItem("topcut",this.currentTable["topcut"])
  //     this.sortTreeItem("topcut",this.currentTable["topcut"])
  //   }
  //   if (this.currentTable["sidecut"] && this.currentTable["sidecut"].length) {
  //     // this.toplineTreeItems["sidecut"] = this.sortTreeItem("sidecut",this.currentTable["sidecut"])
  //     this.sortTreeItem("sidecut",this.currentTable["sidecut"])
  //   }
  //   if (this.currentTable["tablecut"] && this.currentTable["tablecut"].length) {
  //     // this.toplineTreeItems["table"] = this.sortTreeItem("table",this.currentTable["tablecut"])
  //     this.sortTreeItem("table",this.currentTable["tablecut"])
  //   }
  // }

  sortTreeItem(tree,cutType,selectedItems){
    if (selectedItems && selectedItems.length) {
      let selectedItemsIds = this.getSelectedIds(selectedItems);
      tree = this.recursivlySortTreeLevels(tree,selectedItemsIds);
      let tempObj = {"tree":tree,"isSortingDone":true}
      return tempObj;
    }else{
      // tree = (this.originalToplineTreeItems[cutType] && this.originalToplineTreeItems[cutType].length) ? JSON.parse(JSON.stringify(this.originalToplineTreeItems[cutType])) : tree;
      let tempObj = {"tree":tree,"isSortingDone":false}
      return tempObj;
    }
  }

  // sortTreeItem(cutType,selectedItems){
  //   if (selectedItems && selectedItems.length) {
  //     let selectedItemsIds = this.getSelectedIds(selectedItems);
  //     this.toplineTreeItems[cutType] = this.recursivlySortTreeLevels(this.toplineTreeItems[cutType],selectedItemsIds)
  //   }else{
  //     this.toplineTreeItems[cutType] = JSON.parse(JSON.stringify(this.originalToplineTreeItems[cutType]))
  //   }
  // }

  getSelectedIds(selectedItems){
    let selectedItemsIds = []
    selectedItems.forEach(cut => {
      let splitOption = [];
      splitOption = cut['parent'].split('---');
      splitOption.push(cut['uuid']);
      splitOption.splice(0,1);
      selectedItemsIds = [...selectedItemsIds,...splitOption]
    });
    selectedItemsIds = this.removeDuplicates(selectedItemsIds);
    return selectedItemsIds;
  }

  removeDuplicates(arr) {
    return arr.filter((item,index) => arr.indexOf(item) === index);
  }

  bubbleSortLevel = (arr,selectedItemsIds,sortBySelectionOrder) => {
    let swapped;
    do {
      swapped = false;
      for (let i = 0; i < arr.length - 1; i++) {
        if (!selectedItemsIds.includes(arr[i].uuid) &&  selectedItemsIds.includes(arr[i + 1].uuid) && !sortBySelectionOrder) {
          let temp = arr[i];
          arr[i] = arr[i + 1];
          arr[i + 1] = temp;
          swapped = true;
        }
      }
    } while (swapped);
  
    return arr;
  };
  
  recursivlySortTreeLevels(tree,selectedItemsIds){    
    tree = this.bubbleSortLevel(tree,selectedItemsIds,false)
    tree.forEach(treeItem => {
      if (treeItem && treeItem.children && treeItem.children.length) {
        this.recursivlySortTreeLevels(treeItem.children,selectedItemsIds)
      }else{
        return tree
      }
    });
    return tree
  }

  searchTree(element, matchingTitle){
    if(element.id.trim() == matchingTitle.trim()){
         return element;
    }else if (element.children != null){
         var i;
         var result = null;
         for(i=0; result == null && i < element.children.length; i++){
              result = this.searchTree(element.children[i], matchingTitle);
         }
         return result;
    }
    return null;
  }

  closeToplineParameter() {
    this.isToplineParameter = false;
  }
  
  openToplineAlias(){
    this.aliastoTableBackButtonShow = true;
    this.router.navigate(['topline/report/alias',this.crosstab_fileUUID]);
    // this.router.navigate(['home/repository-report/topline/alias',this.crosstab_fileUUID]);
  }

  getUniqueTableArr(table: any){
    let uniqueTable = []
    table.forEach(tableKey => {
      let isDublicate = uniqueTable.find(item =>{ return item.name == this.sidecutV2[tableKey].name});
      if (!isDublicate && this.sidecutV2[tableKey].name.toLowerCase() != "unnamed") {
        uniqueTable.push({"name":this.sidecutV2[tableKey].name, "newName":this.sidecutV2[tableKey].name})
      }
    });
    return uniqueTable;
  }

  getUniqueSidecutArr(sidecut: any){
    let uniqueSidecut = []
    Object.keys(sidecut).forEach(cut => {
      sidecut[cut]["options"].forEach(cutOption => {
        let isDublicate = uniqueSidecut.find(item =>{ return item.name == cutOption.v});
        // if (!isDublicate && cutOption.toLowerCase() != "unnamed" && !cutOption.toLowerCase().includes('base')) {
        //   uniqueSidecut.push({"name":cutOption,"newName":cutOption})
        // }
        if (!isDublicate && cutOption.v.toLowerCase() != "unnamed") {
          uniqueSidecut.push({"name":cutOption.v,"newName":cutOption.v})
        }
      });
    });
    return uniqueSidecut;
  }

  getUniqueTopcutArr(obj:any){    
    Object.keys(obj).forEach(element => {
      let item = obj[element];
      // let isDublicate = this.linearDataList['topcut'].find(listItem => {return listItem.name.toLowerCase() == element.toLowerCase()});
      let isDublicate = this.linearDataList['topcut'].find(listItem => {return listItem.name.toLowerCase() == item.name.toLowerCase()});
      if (!isDublicate && element.toLowerCase() != "unnamed") {
        // this.linearDataList['topcut'].push({"name": element, "newName":element});
        this.linearDataList['topcut'].push({"name": item.name, "newName":item.name});
      }
      if(item.options && Object.keys(item.options).length > 0){
        this.getUniqueTopcutArr(item.options);
      }
    });

  }

  setCutToAliasData(){
    this.linearDataList['tables'] = [];
    this.linearDataList['sidecut'] = [];
    this.linearDataList['topcut'] = [];
    let tables = Object.keys(this.sidecutV2);
    // tables.forEach(item =>{
    //   this.linearDataList['tables'].push({"name":this.sidecutV2[item].name, "newName":this.sidecutV2[item].name})
    //   // this.linearDataList['tables'].push({"name":item, "newName":item})
    // })
    this.linearDataList['tables'] = this.getUniqueTableArr(tables);
    this.linearDataList['sidecut'] = this.getUniqueSidecutArr(this.sidecutV2);
    this.topcutV2.forEach(cut => {
      this.getUniqueTopcutArr(cut['topcut']);
    });

    // Refactoring alias text when creating and displaying
    this.refactorAliasText({data: this.linearDataList}).subscribe(
      result =>{
        this.isLoading = false;
        if (result['status'] == 1) {
          this.linearDataList = result['payload']
        }
        this.getList()
      },
      error => {
        this.isLoading = false;
        this.getList()
      }
    )
    // this.getList()
  }


  

  viewCreateTopline(fileDetails){
    this.getAlias(fileDetails['file_uuid']).subscribe(
      result =>{
        this.isLoading = false;
        if (result['status'] == 1) {
          this.aliasData = result['data'][0];
          // console.log(this.aliasData,'aliasData');
          this.aliasJsonToArrConverter();
          this.isAliasData = true;
        }else if (result['status'] == 2) {
          this.isAliasData = false;
        }
        this.getCrosstabs(fileDetails);
      },
      error => {
        this.isLoading = false;
      }
    )
  }

  // getCrosstabs(fileDetails){
  //   this.reportService.allfilesDetails();
  //   let body = {"uuid":fileDetails['file_uuid']}
  //   this.reportService.getCut(body).subscribe(
  //     data => {
  //       if (data['status'] == 1) {
  //         this.isLoading = false;
  //         this.sidecutV2 = data['result']['sidecut'];
  //         this.topcutV2 = data['result']['topcut'];
  //         this.sidecutTreeJSON = [];
  //         this.valueTreeJSON = [];
  //         this.dataTreeJSON = [];
  //         this.toplineTreeItems = {"table":[],"topcut":[],"sidecut":[]};
  //         this.createTreeObj(data['result']['topcut'],fileDetails['file_uuid']);
  //         this.createSidecutTreeObj(this.sidecutV2,fileDetails['file_uuid']);
  //         this.createValueTreeObj(this.sidecutV2,fileDetails['file_uuid']);
  //         if (!this.isAliasData) {
  //           this.setCutToAliasData()
  //         }
  //       }else{
  //         this.notifier.notify('error',data['errorMessage']);
  //         this.isLoading = false;
  //       }
  //     },
  //     error => {
  //       this.isLoading = false;
  //     }
  //   )
  // }

 getCrosstabs(fileDetails){
    this.reportService.allfilesDetails();
    let file_uuid = fileDetails['crossTabId'] ? fileDetails['crossTabId'] : fileDetails['file_uuid'];
    let body = {"uuid":file_uuid}
    this.reportService.getCut(body).subscribe(
      data => {
        if (data['status'] == 1) {
          this.isLoading = false;
          this.sidecutV2 = data['result']['sidecut'];
          this.topcutV2 = data['result']['topcut'];
          this.sidecutTreeJSON = [];
          this.valueTreeJSON = [];
          this.dataTreeJSON = [];
          this.toplineTreeItems = {"table":[],"topcut":[],"sidecut":[]};
          this.originalToplineTreeItems = {"table":[],"topcut":[],"sidecut":[]};
          this.createTreeObj(data['result']['topcut'],file_uuid);
          this.createSidecutTreeObj(this.sidecutV2,file_uuid);
          this.createValueTreeObj(this.sidecutV2,file_uuid);
          if (!this.isAliasData) {
            this.setCutToAliasData()
          }
        }else if(data['status'] == 4){
          this.notifier.notify('error',data['message']);
          this.sidePanelService.afterLoginNavigate();
          // this.isLoading = false;
        }else{
          this.notifier.notify('error',data['errorMessage']);
          this.isLoading = false;
        }
      },
      error => {
        this.isLoading = false;
      }
    )
  }

  getList(){
    let table = this.linearDataList['tables'];
    let sidecut = this.linearDataList['sidecut']
    let topcut = this.linearDataList['topcut']
    this.filterStreetData =  table;
    this.tableListForToplineParams = this.filterStreetData
    if (this.searchText != '') {
      table = table.filter(item =>{ return item.name.toLowerCase().includes(this.searchText.toLowerCase()) || item.newName.toLowerCase().includes(this.searchText.toLowerCase())})
      topcut = topcut.filter(item =>{ return item.name.toLowerCase().includes(this.searchText.toLowerCase()) || item.newName.toLowerCase().includes(this.searchText.toLowerCase())})
      sidecut = sidecut.filter(item =>{ return item.name.toLowerCase().includes(this.searchText.toLowerCase()) || item.newName.toLowerCase().includes(this.searchText.toLowerCase())})
    }
    this.listTypes.tableList = this.onListPartition(table);
    this.listTypes.topcutList = this.onListPartition(topcut);
    this.listTypes.sidecutList = this.onListPartition(sidecut);
    this.switchTabs(this.activeTab);
  }

  onListPartition(list:any[]){
    let rawList = {list:[],evenList:[],oddList:[]}
    rawList['list'] = list
    list.forEach((item, index) => {
      item['pindex'] = index;
      if (index % 2 == 0) {
        rawList['evenList'].push(item)
      }else{
        rawList['oddList'].push(item)
      }
    });
    return rawList
  }

  switchTabs(tab:string){
    this.activeTab = tab;
    switch (this.activeTab) {
      case "tables":
        this.activatedPrefix = "_table";
        this.listItems = this.listTypes.tableList;
        break;
      case "side cuts":
        this.activatedPrefix = "_sidecut";
        this.listItems = this.listTypes.sidecutList;
        break;
      case "top cuts":
        this.activatedPrefix = "_topcut";
        this.listItems = this.listTypes.topcutList;
        break;
      default:
        this.listItems = this.listTypes.tableList;
        break;
    }
  }

  switchTreeTabs(tabs:string){
    this.activeTreeTab = tabs;
    this.sidecutChangeDetector()
  }

  setSidecutHistory(){
    this.currentTable['sidecutHistory'] = [];
    this.currentTable['customOptionHistory'] = [];
    if (this.currentTable['sidecut'] && this.currentTable['sidecut'].length) {
      this.currentTable['sidecutHistory'] = this.currentTable['sidecut'].map((cut) =>{ return cut.uuid});
    }
    if (this.currentTable['custom_options'] && this.currentTable['custom_options'].length) {
      this.currentTable['custom_options'].forEach(cOption => {
        this.currentTable['customOptionHistory']  = [...this.currentTable['customOptionHistory'] ,...cOption["options"].map((cut)=>{return cut.uuid})]
      });
    }
    // console.log("this.currentTable in setSidecutHistory ====> ",this.currentTable)
  }

  sidecutChangeDetector(){
    // console.log("in sidecutChangeDetector")
    if (this.currentTable['sidecut'] && this.currentTable['sidecut'].length) {
      let sidecutHistory = [];
      let customOptionHistory = [];
      let isCheckCustomOption = false;
      let isAutoSelectTableDone = false;
      if (this.currentTable['sidecutHistory'].length == 0) {
        this.autoSelectTable();
      }else{
        sidecutHistory = this.currentTable['sidecut'].map((cut) =>{ return cut.uuid});
        if (this.currentTable['custom_options'] && this.currentTable['custom_options'].length) {
          isCheckCustomOption = true
          this.currentTable['custom_options'].forEach(cOption => {
            customOptionHistory = [...customOptionHistory,...cOption["options"].map((cut)=>{return cut.uuid})]
          });
        }
        if (this.currentTable['sidecutHistory'].length == sidecutHistory.length) {
          this.currentTable['sidecutHistory'].forEach(cutUUID => {
            if (!sidecutHistory.includes(cutUUID)) {
              this.autoSelectTable();
              isAutoSelectTableDone = true;
            }
          });
        }else{
          this.autoSelectTable();
          isAutoSelectTableDone = true;
        }

        if (!isAutoSelectTableDone) {
          if (isCheckCustomOption && this.currentTable['customOptionHistory'].length == customOptionHistory.length) {
            // console.log("in isCheckCustomOption")
            this.currentTable['customOptionHistory'].forEach(cutUUID => {
              if (!customOptionHistory.includes(cutUUID)) {
                this.autoSelectTable();
                isAutoSelectTableDone = true;
              }
            });
          }
          else{
            this.autoSelectTable();
            isAutoSelectTableDone = true;
          }
        }
      }
    }else{
      this.currentTable['tablecut'] = [];
    }
  }

  autoSelectTable(){
    this.setSidecutHistory();
    // console.log("auto select called")
    this.currentTable['tablecut'] = [];
    let selectedSideCutUUID = [];
    selectedSideCutUUID = this.currentTable['sidecut'].map((cut) =>{ return cut.parent_uuid});
    if (this.currentTable['custom_options'] && this.currentTable['custom_options'].length) {
      this.currentTable['custom_options'].forEach(cOption => {
        selectedSideCutUUID  = [...selectedSideCutUUID ,...cOption["options"].map((cut)=>{return cut.parent_uuid})]
      });
    }
    selectedSideCutUUID = this.removeDuplicates(selectedSideCutUUID);
    selectedSideCutUUID.forEach(sideCutUUid => {
      let duplicateTablecut = null
      duplicateTablecut = this.currentTable['tablecut'].find((tableCut) =>{return tableCut.uuid == sideCutUUid})
      if (!duplicateTablecut || duplicateTablecut == null) {
        this.currentTable['tablecut'].push(this.toplineTreeItems['table'][0]["children"].find((tableCut) =>{return tableCut.uuid == sideCutUUid}))
      }
    });
  }

 

  aliasArrToJsonConverter(){
      let aliasObj = {"table":{},"topcut":{},"sidecut":{}};
      this.linearDataList['tables'].forEach(tableItem => {
        aliasObj["table"][tableItem.name] = (tableItem.newName && tableItem.newName !="") ?{name:tableItem.name,newName:tableItem.newName} : {name:tableItem.name}
        // aliasObj["table"][tableItem.name + "_table"] = (tableItem.newName && tableItem.newName !="") ?{name:tableItem.name,newName:tableItem.newName} : {name:tableItem.name}
      });
      this.linearDataList['topcut'].forEach(topcutItem => {
        aliasObj["topcut"][topcutItem.name] = (topcutItem.newName && topcutItem.newName !="") ?{name:topcutItem.name,newName:topcutItem.newName} : {name:topcutItem.name}
        // aliasObj["topcut"][topcutItem.name + "_topcut"] = (topcutItem.newName && topcutItem.newName !="") ?{name:topcutItem.name,newName:topcutItem.newName} : {name:topcutItem.name}
      });
      this.linearDataList['sidecut'].forEach(sidecutItem => {
        aliasObj["sidecut"][sidecutItem.name] = (sidecutItem.newName && sidecutItem.newName !="") ?{name:sidecutItem.name,newName:sidecutItem.newName} : {name:sidecutItem.name}
        // aliasObj["sidecut"][sidecutItem.name + "_sidecut"] = (sidecutItem.newName && sidecutItem.newName !="") ?{name:sidecutItem.name,newName:sidecutItem.newName} : {name:sidecutItem.name}
      });
      let body = {data : aliasObj};
      if (this.excelviewer_fileUUID && this.excelviewer_fileUUID != "") {
        body["file_uuid"] = this.excelviewer_fileUUID
      }
      this.postAlias(body).subscribe(
        result =>{
          if (result['status'] == 1) {
            this.notifier.notify("success","Alias saved successfully")
            this.setExcelviewerFileUUID(result["file_id"]);
            this.redirectToExcelViewer();
          }else{
            this.notifier.notify("error","Something went wrong!")
          }
        },error =>{
          console.log(error)
        }
      )
  }

  redirectToExcelViewer(){
    this.reportService.studyId = ""
    this.router.navigate(['/topline/excel-view',this.excelviewer_fileUUID])
    // this.router.navigate(['/home/repository-report/excel-view',this.excelviewer_fileUUID])
  }

  aliasJsonToArrConverter(){
    this.linearDataList['tables'] = [];
    this.linearDataList['sidecut'] = [];
    this.linearDataList['topcut'] = [];

    Object.keys(this.aliasData["table"]).forEach(tableKey => {
      this.linearDataList['tables'].push(this.aliasData["table"][tableKey]) 
    });
    Object.keys(this.aliasData["sidecut"]).forEach(sidecutKey => {
      this.linearDataList['sidecut'].push(this.aliasData["sidecut"][sidecutKey]) 
    });
    Object.keys(this.aliasData["topcut"]).forEach(topcutKey => {
      this.linearDataList['topcut'].push(this.aliasData["topcut"][topcutKey]) 
    });
    this.getList();
  }

  getAlias(file_uuid?:string){
    let opt = {};
    if (this.excelviewer_fileUUID && this.excelviewer_fileUUID != "") {
      opt['query'] = {"file_uuid":this.excelviewer_fileUUID}
    }
    return this.apiRequest.request('GET','/v2/excelviewer/getDataTableExcelViewerData/'+this.crosstab_fileUUID+'/alias',{},opt);
    // return this.apiRequest.request('GET','/v2/excelviewer/getDataTableExcelViewerData/'+file_uuid+'/alias',{},opt);
  }

  postAlias(body:any){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile;
    return this.apiRequest.request('POST','/v2/excelviewer/saveDataTableExcelViewerData/'+this.crosstab_fileUUID+'/alias',body,opt);
    // return this.apiRequest.request('POST','/v2/excelviewer/saveDataTableExcelViewerData/'+this.fileDetails['file_uuid']+'/alias',body,opt);
  }

  createTreeObj(topcutObj,file_uuid){
    this.isTopcutLoaded = false;
    let newTopcutObj = [{id:0,topcut:{"Select All": {
      "type": "option",
      "index": 0,
      "sType":"All",
      "name":"Select All"
    }}}]
    // let newTopcutObj = []
    topcutObj.forEach(topcut =>{
      newTopcutObj.push(topcut)
    })
    this.treeItems[file_uuid] = [];
    newTopcutObj.forEach((topcut, index) => {
        this.recurciveTreeObj(topcut['topcut'], 'root', 'root', 'root', topcut['id']+'-', topcut['id'], this.dataTreeJSON);
    });
    setTimeout(()=>{
      let treeArray = this.process(this.dataTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
          // this.treeItems[file_uuid].push(item);
        }
      });
      this.treeItems[file_uuid].push(treeObj);
      this.isTopcutLoaded = true;
    },100)
    this.toplineTreeItems["topcut"] = this.treeItems[file_uuid];
    this.originalToplineTreeItems["topcut"] = this.treeItems[file_uuid];
    // this.originalToplineTreeItems["topcut"] = JSON.parse(JSON.stringify(this.treeItems[file_uuid]));
    // console.log("topcut treeItems +_+_++_+_+_+> ",JSON.stringify(this.treeItems[file_uuid]));
    // console.log("this.originalToplineTreeItems[topcut]+_+_++_+_+_+> qq ",this.originalToplineTreeItems["topcut"]);
  }

  createSidecutTreeObj(sidecutV2:any,file_uuid){
    this.isSidecutLoaded = false;
    let newSidecutObject = {};
    // newSidecutObject['Select All'] = {"options":[],"allowed_topcuts":[0]};
    newSidecutObject['Select All'] = {"name":"Select All","options":[],"allowed_topcuts":[0],"sType":"All"};
    Object.keys(sidecutV2).forEach(key =>{
      newSidecutObject[key] = sidecutV2[key];
    })
    this.sidecutTreeitems[file_uuid] = [];
    Object.keys(newSidecutObject).forEach((key, index) =>{
      let obj = {};
      let sidecutObject = {};
      obj['type'] = 'topcut';
      obj['v'] = newSidecutObject[key]['name'];
      obj['allowed_topcuts'] = newSidecutObject[key]['allowed_topcuts'][0];
      let obj1 = {};
      newSidecutObject[key]['options'].forEach((va,i) =>
      {
        obj1[i] = va;
      })
      obj['options'] = obj1;
      sidecutObject[key] = obj;
      this.recurciveSideTreeObj(sidecutObject, 'root', "root", 'root', sidecutObject[key]['allowed_topcuts']+'-', sidecutObject[key]['allowed_topcuts'], this.sidecutTreeJSON);
    });
    setTimeout(()=>{
      
      let treeArray = this.process(this.sidecutTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
          // this.sidecutTreeitems[file_uuid].push(item);
        }
      });
      this.sidecutTreeitems[file_uuid].push(treeObj);
      this.isSidecutLoaded = true;
    },100)
    this.toplineTreeItems["sidecut"] = this.sidecutTreeitems[file_uuid];
    this.originalToplineTreeItems["sidecut"] = this.sidecutTreeitems[file_uuid];
    // console.log("this.toplineTreeItems sidecut",this.toplineTreeItems["sidecut"] )
  }

  createValueTreeObj(sidecutV2:any,file_uuid){
    this.isTavleCutLoaded = false;
    let newSidecutObject = {};
    // newSidecutObject['Select All'] = {"options":[],"allowed_topcuts":[0],"sType":"All"};
    newSidecutObject['Select All'] = {"name":"Select All","options":[],"allowed_topcuts":[0],"sType":"All"};
    Object.keys(sidecutV2).forEach(key =>{
      newSidecutObject[key] = {name :sidecutV2[key]["name"], options:[]};
    })
    this.valueTreeitems[file_uuid] = [];
    Object.keys(newSidecutObject).forEach((key, index) =>{
      let obj = {};
      let sidecutObject = {};
      if (newSidecutObject[key]['sType'] && newSidecutObject[key]['sType'] == 'All') {
        obj['type'] = 'topcut';
      }
      obj['v'] = newSidecutObject[key]['name'];
      obj['allowed_topcuts'] = "0";
      let obj1 = {};
      newSidecutObject[key]['options'].forEach((va,i) =>
      {
        obj1[i] = va;
      })
      obj['options'] = obj1;
      sidecutObject[key] = obj;
      this.recurciveTableTreeObj(sidecutObject, 'root', 'root', 'root', sidecutObject[key]['allowed_topcuts']+'-', sidecutObject[key]['allowed_topcuts'], this.valueTreeJSON);
    });
    setTimeout(()=>{
      let treeArray = this.process(this.valueTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
          // this.valueTreeitems[file_uuid].push(item);
        }
      });
      this.valueTreeitems[file_uuid].push(treeObj);
      this.isTavleCutLoaded = true;
    },100)
    this.toplineTreeItems["table"] = this.valueTreeitems[file_uuid];
    this.originalToplineTreeItems["table"] = this.valueTreeitems[file_uuid];
    // console.log("this.toplineTreeItems table",this.toplineTreeItems["table"] )
  }

  recurciveTreeObj(topcut, parent, parentName, parent_id, id, allowed_topcuts, treeJson){
    
    Object.keys(topcut).forEach((key, index)=>{
      let dataItem = {};
      // dataItem['id'] = id + '' + parent + '---' + key;
      // dataItem['name'] = key;
      let cutName = topcut[key]["name"];
      let parentId = parent_id;
      // let parentId = parent;
      dataItem['p'] = '';
      if (parentName.split('---').length > 1) {
        dataItem['p'] = parentName.split('---')[1];
        // parentId = parentId + "$$$" + parentName;
      }else{
        dataItem['p'] = cutName;
      }
      // dataItem['id'] = id + '' + parentId + '---' + key + "$$$" + cutName;
      parentId = parentId + '---' + key + "$$$" + cutName;
      dataItem['id'] = id + '' + parentId;
      dataItem['name'] = cutName;
      dataItem['uuid'] = key;
      dataItem['parent'] = parent;
      dataItem['parentName'] = parentName;
      dataItem['allowed_topcuts'] = allowed_topcuts
      dataItem['show'] = false;
      dataItem['n'] = topcut[key]['n'];
      dataItem['dindex'] = "";

      if (topcut[key]["dindex"] >=0) {
        dataItem['dindex'] = topcut[key]["dindex"];
        // console.log(typeof(topcut[key]["dindex"]))
      }
      if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
        dataItem['sType'] = 'All'; 
      }
      
      // console.log("this.dataTreeJSON ==> ",this.dataTreeJSON)
      if(topcut[key]['type'] == 'topcut'){
        dataItem['children'] = [];
        treeJson.push(dataItem);
        if (dataItem['sType'] == 'All') {
          this.recurciveTreeObj(topcut[key]['options'], parent, parentName, parentId, id, allowed_topcuts, dataItem['children']);
        }else{
          this.recurciveTreeObj(topcut[key]['options'], parent+'---'+key, parentName+'---'+cutName, parentId, id, allowed_topcuts, dataItem['children']);
        }
      }else{
        treeJson.push(dataItem);
      }
    });
  }

  recurciveSideTreeObj(topcut, parent, parentName, parent_id, id, allowed_topcuts, treeJson, isJsonShortingArray?:boolean){
    Object.keys(topcut).forEach((key, index)=>{
      let dataItem = {};
      // let keyName = isJsonShortingArray ? topcut[key] : key
      let keyName = isJsonShortingArray ? topcut[key]["label"] : key;
      let cutName = topcut[key]["v"];
      let parentId = parent_id;
      dataItem['p'] = '';
      if (parentName.split('---').length > 1) {
        dataItem['p'] = parentName.split('---')[1];
        // parentId = parentId + "$$$" + parentName;
      }else{
        dataItem['p'] = cutName;
      }
      // dataItem['id'] = id + '' + parent + '---' + keyName;
      // dataItem['name'] = keyName;
      // dataItem['id'] = id + '' + parentId + '---' + keyName + "$$$" + cutName;
      parentId = parentId + '---' + keyName + "$$$" + cutName;
      dataItem['id'] = id + '' + parentId;
      dataItem['name'] = cutName;
      dataItem['uuid'] = keyName;
      dataItem['parent'] = parent;
      dataItem['parent_uuid'] = '';
      dataItem['allowed_topcuts'] = allowed_topcuts
      dataItem['show'] = false;
      dataItem['selectionOrder'] = topcut[key]['selectionOrder'];
      dataItem['selectionMethod'] = topcut[key]['selectionMethod'];

      // dataItem['sequence'] = index;
      dataItem['n'] = topcut[key]['n'];
      if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
        dataItem['sType'] = 'All'; 
      }
      if (parent.split('---').length > 1) {
        dataItem['parent_uuid'] = parent.split('---')[1];
      }else{
        dataItem['parent_uuid'] = key;
      }
      if(topcut[key]['type'] == 'topcut'){
        dataItem['children'] = [];
        treeJson.push(dataItem);
        if (dataItem['sType'] == 'All') {
          this.recurciveSideTreeObj(topcut[key]['options'], parent, parentName, parentId, id, allowed_topcuts, dataItem['children']);
        }else{
          this.recurciveSideTreeObj(topcut[key]['options'], parent+'---'+key, parentName+'---'+cutName, parentId, id, allowed_topcuts, dataItem['children'],true);
        }
      }else{
        treeJson.push(dataItem);
      }
    });
  }

  recurciveTableTreeObj(topcut, parent, parentName, parent_id, id, allowed_topcuts, treeJson, isJsonShortingArray?:boolean){
    Object.keys(topcut).forEach((key, index)=>{
      let dataItem = {};
      // let keyName = isJsonShortingArray ? topcut[key] : key
      // dataItem['id'] = id + '' + parent + '---' + keyName;
      // dataItem['name'] = keyName;
      let keyName = isJsonShortingArray ? topcut[key]["label"] : key;
      let cutName = topcut[key]["v"]
      let parentId = parent_id;
      dataItem['p'] = '';
      if (parentName.split('---').length > 1) {
        dataItem['p'] = parentName.split('---')[1];
        // parentId = parentId + "$$$" + parentName;
      }else{
        dataItem['p'] = cutName;
      }
      // dataItem['id'] = id + '' + parent + '---' + keyName + "$$$" + cutName;
      // dataItem['id'] = id + '' + parentId + '---' + keyName + "$$$" + cutName;
      parentId = parentId + '---' + keyName + "$$$" + cutName;
      dataItem['id'] = id + '' + parentId;
      dataItem['name'] = cutName;
      dataItem['uuid'] = keyName;
      dataItem['parent'] = parent;
      dataItem['parent_uuid'] = '';
      dataItem['allowed_topcuts'] = allowed_topcuts
      dataItem['show'] = false;
      // dataItem['sequence'] = index;
      dataItem['n'] = topcut[key]['n'];
      if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
        dataItem['sType'] = 'All'; 
      }
      if (parent.split('---').length > 1) {
        dataItem['parent_uuid'] = parent.split('---')[1];
      }else{
        dataItem['parent_uuid'] = key;
      }
      if(topcut[key]['type'] == 'topcut'){
        dataItem['children'] = [];
        treeJson.push(dataItem);
        if (dataItem['sType'] == 'All') {
          this.recurciveTableTreeObj(topcut[key]['options'], parent, parentName, parentId, id, allowed_topcuts, dataItem['children']);
        }else{
          this.recurciveTableTreeObj(topcut[key]['options'], parent+'---'+key, parentName+'---'+cutName, parentId, id, allowed_topcuts, dataItem['children'],true);
        }
      }else{
        treeJson.push(dataItem);
      }
    });
  }

  public process(data): any {
    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }

  private toTreeNode(node, parent = null) {
    if (node && node.children) {
      node.children.map((item) => {
        return this.toTreeNode(item, node);
      });
    }
    return node;
  }

  changeSheetIndex(ind:any){
    this.sheetContainerIndex = ind;
  }

  resetTopLineForm(){
    this.sheetContainerIndex = 0;
    this.activeTreeTab = 'top cuts';
    this.currentTable = {}
    this.insertSheetItem();
  }

  insertSheetItem(){
    this.currentTable = {
      topcut:[],
      sidecut:[],
      tablecut:[],
      topcutValue:'topcut',
      sidecutValue:'sidecut',
      tablecutValue:'table',
      table_name:'',
      sidecutHistory:[]
      // showHeader:false
    }
  }

  createExcelview(body:any){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile;
    if (this.excelviewer_fileUUID != "") {
      body["file_id"] = this.excelviewer_fileUUID
    }
    return this.apiRequest.request('POST','/v2/excelviewer/createExcelViewer/'+this.crosstab_fileUUID,body,opt);
  }

  refactorAliasText(body:any){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile;
    return this.apiRequest.request('POST','/v2/excelviewer/alias-refactor',body,opt);
  }

  // getTreeFromSelectedOption(topcutJson,optionType?){
  //       let topcutTree = [];
  //       let selectedTopCuts = [{"options":topcutJson}]
  //       selectedTopCuts.forEach(top => {
  //        let topcutObj = {};
  //        topcutObj['id'] = this.findID(top.options);
  //        topcutObj['topcut'] = {};
  //        top.options.forEach( option => {
  //          let splitOption = option['parent'].split('---');
  //          let splitParentName = option['parentName'].split('---');
  //          if (option['sType'] && option['sType'] == "All") {
  //            // isAllTopcut = true;
  //          }else{
  //            if (option['name']) {
  //               splitParentName.push(option['name']);
  //             }
  //            if (option['uuid']) {
  //               splitOption.push(option['uuid']);
  //             }
  //            splitParentName.splice(0,1);
  //            splitOption.splice(0,1);
  //            let map = topcutObj['topcut'];
  //            for (let i = 0; i < splitOption.length; i++) {
  //              let item = splitOption[i];
  //              map[item] = map[item] || {};
  //              if (Object.keys(map[item]).length > 0 || i < splitOption.length - 1) {
  //                map[item]['name'] = splitParentName[i]
  //               if(optionType === 'level'){
  //                   map[item]['type'] = 'level';
  //               }else{
  //                   map[item]['type'] = 'topcut';
  //               }
  //              }else{
  //                map[item] = option;
  //                map[item]['type'] = 'option';
  //                map[item]['show'] = option.show;
  //                map[item]['index'] = option["dindex"];
  //              }
  //              map[item]['options'] = map[item]['options'] || {};
  //              map = map[item]['options'];
  //            }
  //          }
  //        });
  //        this.removeEmptyOptions(topcutObj['topcut']);
  //        topcutTree.push(topcutObj);
  //      });
  //       return topcutTree[0]["topcut"]
  //     }

  //     findID(options){
  //       let len = 0;
  //       let key = '';
  //       options.forEach( (option) => {
  //         const arr = option['parent'].split('---');
  //         if(arr.length > len){
  //           len = arr.length;
  //           key = arr[1];
  //         }
  //       });
  //       return options[0].id.split('-')[0];
  //     }
  //     removeEmptyOptions(topcutObj){
  //       Object.keys(topcutObj).forEach((key)=>{
  //             if(Object.keys(topcutObj[key]['options']).length == 0){
  //               delete topcutObj[key]['options'];
  //             }else{
  //               this.removeEmptyOptions(topcutObj[key]['options']);
  //             }
  //       })
  //     }

 
}
